import { createSlice } from '@reduxjs/toolkit'
import { failed } from '../../../reducer-helper'
import { deletePaymentMethod } from '../../../../components/workspace/settings/billing/payment-methods/slice'

const initialState = {
  data: {
    paymentMethodId: null,
  },
  showPopup: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'deletePaymentMethodConfirmation',
  initialState,
  reducers: {
    setShowPopupState(state, action) {
      state.showPopup = action.payload.showPopup
      state.data.paymentMethodId = action.payload.paymentMethodId
    },
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
    resetForm: () => initialState,
  },
  extraReducers(builder) {
    builder.addCase(deletePaymentMethod.fulfilled, () => initialState)
    builder.addCase(deletePaymentMethod.rejected, failed)
  },
})

const selectSlice = (state) => state.deletePaymentMethodConfirmation
export const selectData = (state) => selectSlice(state).data
export const selectShowPopup = (state) => selectSlice(state).showPopup
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status

const { reducer, actions } = slice

export const { resetForm, changeRequestStatus, setShowPopupState, setPaymentMethodId } = actions

export default reducer
